<template>
  <div>
    <top-header-info></top-header-info>
    <top-logo state="2"></top-logo>
    <!-- <right-nav></right-nav> -->
    <div class="bg-wrapper" id="top">
      <div class="page page-cart w">
        <!-- <div v-if="!showEmpty && products.length == 0" class="load-wrap">
          <img src="../../assets/images/load.gif" />
        </div> -->
        <div v-if="showEmpty" class="emptycart">
          <img src="../../assets/images/emptycart.png" />
          <p>购物车为空</p>
        </div>
        <div v-if="products && products.length > 0" class="page-title">
          全部商品
          <span>{{ cartInfo }}</span>
        </div>
        <div v-if="products && products.length > 0" class="content">
          <ul class="cart_head_title">
            <li class="th td-product-title">
              <input
                class="selfcheckbox"
                type="checkbox"
                id="check_item_all"
                v-model="select_all"
                @change="checkAll()"
              />
              <!-- <el-checkbox :value="select_all" @change="selectAll()"></el-checkbox> -->
              <label for="check_item_all"></label>&nbsp;&nbsp;&nbsp;全选
            </li>
            <li class="th td-product p0">商品信息</li>
            <li class="th td-price">价格</li>
            <li class="th td-count">数量</li>
            <li class="th td-total">小计</li>
            <li class="th td-actions">操作</li>
          </ul>

          <!-- 上班族商品 -->
          <div
            class="typebox_item"
            v-for="(item, index) in products"
            :key="index"
          >
            <p
              class="cart_list_cat"
              v-if="item.items && item.items.length > 0"
              style="position:relative;"
            >
              <span>
                <!-- <input
                  v-model="item.all_check"
                  class="selfcheckbox check_item_partall"
                  type="checkbox"
                  @change="selectAll(item.all_check)"
                >-->
                <el-checkbox
                  :value="item.all_check"
                  @change="checkAllCate(item)"
                ></el-checkbox>
                <!-- <label for="check_item_all"></label> -->
              </span>
              <span
                @click="goShoppingMall(item.category_type, item.category_id)"
                style="cursor: pointer;"
                >&nbsp;{{ item.name }}</span
              >
              <!-- <span class="sub_title">(自营包邮)</span> -->
              <span class="freightTips" v-if="item.free_shipping > 0">
                <span>
                  <el-popover
                    placement="bottom"
                    width="200"
                    trigger="click"
                    :content="
                      `${item.name.substring(0, 4)}商品满${
                        item.free_shipping
                      }元免运费，最终运费以订单下单页为准。`
                    "
                  >
                    <i class="el-icon el-icon-hint" slot="reference" click></i>
                  </el-popover>

                  <span>{{ item.tips }}</span>
                </span>
                <span
                  v-if="item.diff == item.free_shipping"
                  style="color: #FFAF0F;cursor:pointer;"
                  @click="goShoppingMall(item.category_type, item.category_id)"
                  >去凑单</span
                >
                <span
                  v-else-if="item.diff < item.free_shipping && item.diff !== 0"
                  style="color: #FFAF0F;cursor:pointer;"
                  @click="
                    goAddonItem(
                      false,
                      item.category_type,
                      item.diff,
                      item.diff * 2
                    )
                  "
                  >去凑单</span
                >
              </span>
            </p>
            <table class="product-table" rules="rows">
              <tbody class="product-tbody">
                <tr
                  class="product-item"
                  v-for="product in item.items"
                  :key="product.product_id"
                  :class="{ checkbg: product.checked }"
                >
                  <td
                    class="td-radio"
                    v-if="product.stock && product.can_buy_status"
                  >
                    <!-- <input
                      name="checkable"
                      class="selfcheckbox selfcheckboxchecked"
                      type="checkbox"
                      :value="product.checked==='1'?true:false"
                    >-->
                    <el-checkbox
                      :value="product.checked === '1' || product.checked === 1"
                      @change="selectSingle(product)"
                    ></el-checkbox>
                    <!-- <label for="check_item" @click="selectSingle(product)"></label> -->
                  </td>
                  <td class="td-radio" v-else>
                    <input class="selfcheckbox" type="checkbox" />
                    <label
                      @click="
                        product.not_match_rule !== 1
                          ? stockalert(1)
                          : stockalert(2)
                      "
                    ></label>
                  </td>
                  <td class="td-product">
                    <div class="image">
                      <img :src="product.image" />
                    </div>
                    <div class="info">
                      <div
                        class="name auto-cut-word-two-line"
                        @click="itemClick(product)"
                      >
                        {{ product.name }}
                      </div>
                      <div v-show="product.option_values" class="product-type">
                        <span class="type">{{ product.option_values }}</span>
                        <span class="reset" @click="goodsShow(product)"
                          >修改</span
                        >
                      </div>
                      <div class="sku auto-cut-word-two-line">
                        SKU： {{ product.sku }}
                      </div>
                      <div
                        v-if="product.is_fresh"
                        @click.stop="freshDialogVisible = true"
                        class="refresh-wrap"
                      >
                        <span>生鲜</span>生鲜产品购买须知 &gt;
                      </div>
                      <!-- <div class="refresh-wrap">
                        <el-tooltip
                          class="item"
                          effect="light"
                          content="本商品为包邮商品，如混入其他不包邮商品，则该商品同样会收取相应运费。"
                          placement="top"
                          popper-class="product-tooltip"
                        >
                          <div style="display: inline-block;">
                            <span>包邮</span>包邮须知 &gt;
                          </div>
                        </el-tooltip>
                      </div> -->
                    </div>
                  </td>
                  <td class="td-price">
                    <div class="price">{{ product.special | jifen }}</div>
                  </td>
                  <td class="td-count">
                    <el-input-number
                      v-model="product.quantity"
                      @change="handleChange($event, product)"
                      size="mini"
                      :min="product.minimum"
                    ></el-input-number>
                    <p
                      style="color: #c50102; margin: 0 0 -23px 0"
                      v-if="product.not_match_rule === 1"
                    >
                      **禁售
                    </p>
                    <p
                      style="color: #c50102; margin: 0 0 -23px 0"
                      v-else-if="!product.stock || !product.can_buy_status"
                    >
                      {{ product.can_buy_status_text }}
                    </p>
                  </td>
                  <td class="td-total red_word">{{ product.total | jifen }}</td>
                  <td class="td-actions actions">
                    <div class="action-delete" @click="deleteProduct(product)">
                      <i class="el-icon el-icon-del"></i> 删除
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="cart-footer cart-footer-cart">
            <!-- <div class="select-all"></div> -->
            <!-- {{select_all}} -->
            <div class="cart_check_delete">
              <input
                class="selfcheckbox"
                type="checkbox"
                id="check_item_all_sub"
                v-model="select_all"
                @change="checkAll()"
              />
              <label for="check_item_all_sub"></label>&nbsp;&nbsp;
              <span>全选</span>
              <span
                class="delete_action"
                @click="
                  select_all && isLoseEfficacyGoods.length == 0
                    ? emptyCart()
                    : batchDelProduct()
                "
                >删除选中商品</span
              >
              <span
                v-if="isLoseEfficacyGoods.length > 0"
                class="delete_action"
                @click="delLoseEfficacyGoods"
              >
                删除失效商品
              </span>
            </div>
            <!-- ng-class="checking?'disable_send':''" -->
            <div class="btn-checkout f_r" @click="gotoCheckout()">
              去结算
              <!-- (<span>{{products.length}}</span>) -->
            </div>
            <div class="total-final f_r">
              <p>
                <span>
                  已选中
                  <b class="red_text">{{ selectInfo }}</b> 件商品 &nbsp;&nbsp;
                </span>
                <span v-if="total.coupon.value"
                  >优惠券优惠<span class="red_text">{{
                    Math.abs(total.coupon.value) | jifen
                  }}</span></span
                >
                <span class="product-count">
                  {{
                    total.coupon.value ? "券后价" : "商品总计（预估）"
                  }}：</span
                >
                <span class="price">
                  {{
                    total &&
                      (total.sub_total.value + total.coupon.value) | jifen
                  }}
                </span>
              </p>
              <p class="express_rule_ico" style="cursor: pointer" @click="jump">
                <i class="el-icon el-icon-hint"></i>不含运费，运费规则 &nbsp;
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="修改商品规格" :visible.sync="dialogVisible" width="800px">
      <!-- :before-close="handleClose" -->
      <div class="header">
        <img :src="bigImgUrl" alt />
        <div class="title">
          <div class="name">{{ goodsInfo.name }}</div>
          <div class="price">{{ goodsInfo.special | jifen }}</div>
          <el-row class="goods-small-text">
            <el-col
              class="clearfix"
              v-for="item in goodsInfo.variant_option"
              :key="item.option_id"
              @click.native.stop="isShowSelectAddress = false"
            >
              <span class="Fl-l" style="margin-top: 10px"
                >选择{{ item.name }}</span
              >
              <div class="specification">
                <b
                  :class="{
                    actived: item.select_option_value == i.option_value_id,
                    disabled: i.disabled == true
                  }"
                  v-for="i in item.option_value"
                  :key="i.option_value_id"
                  @click="selectSpecification(item, i)"
                  >{{ i.name }}</b
                >
              </div>
            </el-col>
            <el-col @click.native.stop="isShowSelectAddress = false">
              <span>数量</span>
              <el-input-number
                v-model="product_num"
                size="mini"
                :min="minNum"
              ></el-input-number>

              <span class="can_buy_status">
                {{
                  goodsInfo.can_buy_status === 1
                    ? "有货"
                    : goodsInfo.can_buy_status_text
                }}
              </span>
            </el-col>
          </el-row>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <div
          @click="
            dialogVisible = false;
            init();
          "
        >
          取 消
        </div>
        <div
          type="primary"
          @click="productChange()"
          :class="goodsInfo.can_buy_status !== 1 ? 'grey' : ''"
        >
          确 定
        </div>
      </span>
    </el-dialog>

    <!-- 运费温馨提示 -->
    <el-dialog
      title="温馨提示："
      :visible.sync="freightTipsDialogVisible"
      width="30%"
    >
      <!-- 弹窗叉号不显示 -->
      <!-- :destroy-on-close="true"
      :show-close="false" -->
      <div>
        您的订单中包含未达免运费标准的商品，本次订单将收取运费。
        <p v-for="(item, index) in freightPaymentList" :key="index">
          {{ item.content }}
        </p>
      </div>
      <span
        slot="footer"
        class="dialog-footer"
        style="justify-content: flex-end;"
      >
        <el-button @click="continueCheckout">继续结算</el-button>
        <el-button type="primary" @click="goAddonItem(true)">去凑单</el-button>
      </span>
    </el-dialog>

    <!-- 生鲜提示 -->
    <el-dialog :visible.sync="freshDialogVisible" width="40%">
      <div slot="title">
        <h3 class="dialog-title">生鲜产品购买须知</h3>
      </div>
      <div>1、生鲜产品非质量问题不支持退换;</div>
      <div>2、一经发出后不能取消订单;</div>
      <div>
        3、不支持拒收（有任何问题请先保持签收，并在签收后24小时内联系上班族客服解决，上班族联系方式：400-088-8635
        ，客服邮箱：kefu@shangbanzu.gift）;
      </div>
      <div>
        4、生鲜产品派送时会联系订单收件人进行签收，如个人原因无法现场签收，收件人要求包裹暂放在代收点/指定地点后产生的问题均不予售后。
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="freshDialogVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <bottom-content></bottom-content>
  </div>
</template>
<script>
import TopHeaderInfo from "@/components/top-header-info";
import TopLogo from "@/components/top-logo";
import RightNav from "@/components/right-nav";
import BottomContent from "@/components/bottom-content";
import HomeNav from "@/components/home-nav";
import HomeBanner from "@/components/home-banner";
import { mixinUserbehv } from "@/assets/js/userbehv";
export default {
  components: {
    TopHeaderInfo,
    TopLogo,
    RightNav,
    BottomContent,
    HomeNav,
    HomeBanner
  },
  data() {
    return {
      products: [],
      total: "",
      types: [],
      select_all: false,
      cartInfo: 0,
      selectInfo: 0,
      showEmpty: false,
      message: sessionStorage.getItem("activityMessage"),
      dialogVisible: false,
      last_id: null,
      product_id: null,
      bigImgUrl: "",
      goodsInfo: {},
      minNum: 1,
      product_num: 1,
      skuMap: [],
      freshDialogVisible: false,
      freightPaymentList: [], //需要支付运费的list
      freightTipsDialogVisible: false, //运费温馨提示弹窗
      isLoseEfficacyGoods: [], //自营店失效商品idList
      productAllNum: 0, //购物车全部商品种类数量
      sku_list: [],
      product_id_list: []
    };
  },
  created() {
    this.$bus.$off("change-activity");
    this.$bus.on("change-activity", this.getCart);
  },

  mounted() {
    this.getCart();
  },
  mixins: [mixinUserbehv],
  methods: {
    getCart() {
      this.$reqGet("api/store/cart").then(res => {
        this.productAllNum = 0;
        this.isLoseEfficacyGoods = [];

        let data = res.data.data.products;
        this.total = res.data.data.total;
        this.selectGoods = [];
        this.products = data.filter(item => {
          return item.items.length > 0;
        });

        if (this.products.length == 0) {
          this.showEmpty = true;
        } else {
          this.showEmpty = false;
        }
        var cartNum = 0;
        var selectedNum = 0;
        var checkedAll = true;
        this.sku_list = [];
        this.product_id_list = [];

        //清空运费提示列表
        this.freightPaymentList.splice(0, this.freightPaymentList.length);

        for (const key in data) {
          if (data.hasOwnProperty(key)) {
            const element = data[key];

            //自营店是否有商品选中
            element.is_checked = 0;

            element.items.forEach(item => {
              this.productAllNum++;
              cartNum += parseInt(item.quantity);

              if (item.checked === "1" || item.checked === 1) {
                this.sku_list.push(item.sku);
                this.product_id_list.push(item.product_id);
              }
              if (
                parseInt(item.checked) === 0 &&
                item.stock !== 0 &&
                item.can_buy_status &&
                item.not_match_rule !== 1
              ) {
                checkedAll = false;
              }
              if (item.checked != "0") {
                if (item.stock == 1) {
                  this.selectGoods.push(item.product_id);
                }
                selectedNum += parseInt(item.quantity);
              }

              if (item.stock !== 1) {
                this.isLoseEfficacyGoods.push(item.product_id);
              }
              element.is_checked =
                parseInt(element.is_checked) === 1 ||
                parseInt(item.checked) === 1
                  ? 1
                  : 0;
            });

            //运费提示与凑单
            if (element.is_checked === 0) {
              element.tips = `满${element.free_shipping}元免运费`;
            } else {
              if (Number(element.diff) > 0) {
                element.tips = `还差${element.diff}元免运费`;
              } else {
                element.tips = "已免运费";
              }
            }

            if (
              element.free_shipping > 0 &&
              element.diff > 0 &&
              element.is_checked === 1
            ) {
              this.freightPaymentList.push({
                content: `${element.name.substring(0, 4)}：还差${
                  element.diff
                }元免运费\n`,
                type: element.category_type,
                price_min: element.diff,
                price_max: element.diff * 2
              });
            }
          }
        }
        // this.select_all = checkedAll;
        this.select_all =
          this.productAllNum == this.isLoseEfficacyGoods.length
            ? false
            : checkedAll;
        this.cartInfo = cartNum;
        this.selectInfo = selectedNum;
      });
    },
    //点击跳转商城
    goShoppingMall(type, id) {
      let routeUrl = this.$router.resolve({
        path: "/categoryHome",
        query: { type: type, id: id }
      });
      window.open(routeUrl.href, "_blank");
    },
    handleChange(event, item) {
      this.$reqPut("api/store/cart/" + item.product_id, { qty: event }).then(
        res => {
          if (res.data.success) {
            this.getCart();
          }
        }
      );
    },
    checkAll() {
      if (this.productAllNum == this.isLoseEfficacyGoods.length) {
        this.$nextTick(() => {
          this.select_all = false;
        });
        return;
      }
      this.$reqPost("api/store/cart/checkall", {
        check: this.select_all ? 1 : 0
      }).then(res => {
        if (res.data.success) {
          this.getCart();
        }
      });
    },
    checkAllCate(item) {
      if (this.productAllNum == this.isLoseEfficacyGoods.length) {
        this.$nextTick(() => {
          this.select_all = false;
        });
        return;
      }
      let obj = {
        part_check: item.code
      };
      if (item.all_check) {
        obj.check = 0;
      } else {
        obj.check = 1;
      }
      this.$reqPost("api/store/cart/selectall", obj).then(res => {
        if (res.data.success) {
          this.getCart();
        }
      });
    },
    selectSingle(product) {
      this.$reqPost("api/store/cart/check/" + product.product_id, {
        check: product.checked == 1 ? "0" : "1"
      }).then(res => {
        if (res.data.success) {
          this.getCart();
        }
      });
    },
    deleteProduct(product) {
      this.delHint(product);
    },
    stockalert(key) {
      if (key === 1) {
        this.open("该商品库存不足");
      } else {
        this.open("该商品禁售");
      }
    },
    open(mes) {
      this.$alert(mes, "", {
        confirmButtonText: "确定"
      });
    },
    delHint(product) {
      this.$confirm("确认删除选中商品？", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$reqDel("api/store/cart/" + product.product_id).then(res => {
          if (res.data.success) {
            this.$message({
              type: "success",
              message: "删除成功!"
            });
            this.getCart();
          }
        });
      });
    },
    gotoCheckout() {
      if (this.message) {
        this.$alert(this.message, "提示", {
          confirmButtonText: "确定"
        });
        return;
      }
      if (this.total.sub_total.value <= 0) {
        this.$message({
          type: "warning",
          message: "您还未选择商品"
        });
        return;
      }

      if (this.freightPaymentList.length != 0) {
        this.freightTipsDialogVisible = true;
        return;
      }

      this.setUserbehv(
        this.product_id_list.join(","),
        "buy",
        this.sku_list.join(","),
        this.selectInfo
      );
      this.$router.push({ name: "check-order" });
    },
    // 继续结算
    continueCheckout() {
      this.setUserbehv(
        this.product_id_list.join(","),
        "buy",
        this.sku_list.join(","),
        this.selectInfo
      );
      this.$router.push({ name: "check-order" });
    },
    // 去凑单
    goAddonItem(isMore, type, price_min, price_max) {
      if (isMore && this.freightPaymentList.length > 1) {
        // 凑单弹窗关闭
        this.freightTipsDialogVisible = false;
        return;
      }
      if (!type) {
        type = this.freightPaymentList[0].type;
        price_min = this.freightPaymentList[0].price_min;
        price_max = this.freightPaymentList[0].price_max;
      }
      // if (name.indexOf("（") >= 0) {
      //   name = name.slice(0, name.indexOf("（"));
      // }
      let routeUrl = this.$router.resolve({
        path: "/productList",
        query: {
          type: type,
          price_min: price_min,
          price_max: price_max
        }
      });
      window.open(routeUrl.href, "_blank");
    },
    itemClick(item) {
      this.$router.push({
        name: "product-detail",
        query: {
          product_id: item.product_id
        }
      });
    },
    jump() {
      let routeUrl = this.$router.resolve({
        path: "/introduce",
        query: { title: "配送服务" }
      });
      window.open(routeUrl.href, "_blank");
    },
    emptyCart() {
      this.$confirm("确认删除所有商品？", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$reqGet("api/store/cart/clear").then(res => {
          if (res.data.success) {
            this.$message({
              type: "success",
              message: "删除成功!"
            });
            this.getCart();
          }
        });
      });
    },
    batchDelProduct() {
      if (this.selectGoods.length == 0) {
        this.$message({
          type: "warning",
          message: "尚未选中商品!"
        });
        return;
      }
      this.$confirm("确认删除选中商品？", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$reqDel("api/store/cart/delselect", {}).then(res => {
          if (res.data.success) {
            this.$message({
              type: "success",
              message: "删除成功!"
            });
            this.getCart();
          }
        });
      });
    },
    init() {
      this.last_id = null;
      this.product_id = null;
      this.bigImgUrl = "";
      this.goodsInfo = {};
      this.minNum = 1;
      this.product_num = 1;
      this.skuMap = [];
    },
    async goodsShow(product) {
      this.last_id = product.product_id;
      this.product_id = product.product_id;
      this.product_num = product.quantity;
      await this.getGoodsInfo();
      this.dialogVisible = true;
    },
    productChange() {
      if (this.goodsInfo.can_buy_status !== 1) {
        return;
      }
      if (this.last_id != this.product_id) {
        this.$reqPost("api/store/cart/replace_sku", {
          old_product_id: this.last_id,
          new_product_id: this.product_id,
          qty: this.product_num
        }).then(() => {
          this.getCart();
          this.dialogVisible = false;
        });
      } else {
        this.$reqPut("api/store/cart/" + this.last_id, {
          qty: this.product_num
        }).then(() => {
          this.getCart();
          this.dialogVisible = false;
        });
      }
    },
    async getGoodsInfo() {
      return await this.$reqGet("api/ecomm/product/" + this.product_id).then(
        res => {
          this.goodsInfo = res.data.data;
          this.minNum = this.goodsInfo.minimum || 1;
          this.product_num =
            this.product_num > this.minNum ? this.product_num : this.minNum;
          this.skuMap = this.goodsInfo.sku_map;
          if (this.goodsInfo.variant_option) {
            let skus = this.setSkuList(
              this.goodsInfo.variant_option,
              this.goodsInfo.sku_map
            );
            if (
              skus.length > 0 &&
              !skus.find(item => item.goods_id === this.goodsInfo.product_id)
            ) {
              this.goodsShow({
                product_id: skus[0].goods_id,
                product_num: this.product_num
              });
              return;
            }
            this.variantOption = this.goodsInfo.variant_option;
            this.variantOption.map(item => {
              this.updateAvailabeOptions(item, {
                default: item.select_option_value
              });
            });
          }
          this.goodsInfo.images = this.goodsInfo.images.splice(
            1,
            this.goodsInfo.images.length
          );
          this.bigImgUrl = this.goodsInfo.image;
        }
      );
    },
    setSkuList(variant_option, sku_map) {
      let res = [];
      for (const key in sku_map) {
        if (sku_map.hasOwnProperty(key)) {
          if (sku_map[key]) {
            let sku = {};
            sku.goods_id = sku_map[key];
            res.push(sku);
          }
        }
      }
      return res;
    },
    selectSpecification(item, i) {
      item.select_option_value = i.option_value_id;
      let defaultSpecification = ";";
      this.variantOption.map(item => {
        defaultSpecification +=
          item.option_id + ":" + item.select_option_value + ";";
      });
      for (let key in this.skuMap) {
        if (key == defaultSpecification) {
          this.product_id = this.skuMap[key];
          this.getGoodsInfo();
          break;
        } else {
          this.product_id = "";
          this.updateAvailabeOptions(item, i);
        }
      }
    },
    updateAvailabeOptions(option, optionValue) {
      var selected_options;
      if (typeof optionValue == "object" && optionValue.default) {
        selected_options = [option.option_id + ":" + optionValue.default];
      } else {
        selected_options = [
          option.option_id + ":" + optionValue.option_value_id
        ];
      }
      var sku_map = [];
      for (let b in this.skuMap) {
        sku_map.push(b.split(";"));
      }
      let that = this;
      sku_map = this.getAvailableSkuMap(selected_options, sku_map);
      this.variantOption.forEach(function(vo) {
        if (vo.option_id != option.option_id) {
          vo.option_value.forEach(function(ov) {
            if (!that.isOptionValueInAvailableSkuMap(vo, ov, sku_map)) {
              that.$set(ov, "disabled", true);
              if (ov.option_value_id == vo.select_option_value) {
                vo.select_option_value = 0;
              }
            } else {
              that.$set(ov, "disabled", false);
            }
          });
          if (vo.select_option_value != 0) {
            selected_options.push(vo.option_id + ":" + vo.select_option_value);
            sku_map = that.getAvailableSkuMap(selected_options, sku_map);
          }
        }
      });

      sku_map = [];
      selected_options.shift();
      for (let b in this.skuMap) {
        sku_map.push(b.split(";"));
      }
      sku_map = that.getAvailableSkuMap(selected_options, sku_map);
      this.variantOption.forEach(function(vo) {
        if (vo.option_id == option.option_id) {
          vo.option_value.forEach(function(ov) {
            if (!that.isOptionValueInAvailableSkuMap(vo, ov, sku_map)) {
              that.$set(ov, "disabled", true);
            } else {
              that.$set(ov, "disabled", false);
            }
          });
        }
      });
    },
    getAvailableSkuMap(selected_options, sku_map) {
      var op_in_sku = true,
        sku_map2 = [];
      sku_map.map(function(sm) {
        op_in_sku = true;
        selected_options.map(function(so) {
          if (sm.indexOf(so) == -1) {
            op_in_sku = false;
          }
        });
        if (op_in_sku) {
          sku_map2.push(sm);
        }
      });
      return sku_map2;
    },
    isOptionValueInAvailableSkuMap(option, optionValue, sku_map) {
      var op_in_sku = false,
        selected_option = option.option_id + ":" + optionValue.option_value_id;
      sku_map.forEach(function(sm) {
        if (sm.indexOf(selected_option) != -1) {
          op_in_sku = true;
        }
      });
      return op_in_sku;
    },
    handleClose() {},
    //删除失效商品
    delLoseEfficacyGoods() {
      let data = { product_ids: this.isLoseEfficacyGoods.join(",") };
      this.$confirm("确认删除失效商品？", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$reqPost("api/store/cart/batchDel", data).then(res => {
          if (res.data.success) {
            this.$message({
              type: "success",
              message: "删除成功!"
            });
            this.isLoseEfficacyGoods = [];
            this.getCart();
          }
        });
      });
    }
  }
};
</script>

<style lang="less" scoped>
.page-cart {
  background: #fff;
  padding: 30px;
  box-sizing: border-box;
  .page-title {
    font-size: 24px;
    font-weight: bold;
    color: rgba(34, 34, 34, 1);
    line-height: 61px;
    span {
      color: #f9001f;
    }
  }
}
.page-cart .cart_steps {
  display: block;
  overflow: hidden;
}
.page-cart .cart_steps img {
  width: 564px;
  float: right;
  clear: both;
}
.emptycart {
  height: 300px;
  text-align: center;
  img {
    width: 60px;
    margin-top: 100px;
  }
}
.load-wrap {
  height: 300px;
  text-align: center;
  img {
    width: 100px;
    margin-top: 100px;
  }
}
.page-cart .content .cart_head_title {
  overflow: hidden;
  border: 1px solid #eee;
  background: #f8f8f8;
}
.page-cart .content .cart_head_title li {
  float: left;
  text-align: center;
  height: 50px;
  line-height: 52px;
  font-size: 14px;
  color: #666;
}
.page-cart .content .cart_head_title .td-product-title {
  width: 98px;
  padding-left: 6px;
}
.page-cart .content .cart_head_title .td-product {
  width: 410px;
  position: relative;
  padding-left: 100px;
}
.page-cart .content .cart_head_title .td-price,
.page-cart .content .cart_head_title .td-count,
.page-cart .content .cart_head_title .td-total,
.page-cart .content .cart_head_title .td-actions {
  width: 120px;
}
.page-cart .content .cart_head_title .td-count {
  width: 148px;
}
.page-cart .content .cart_head_title .td-total,
.page-cart .content .cart_head_title .td-actions {
  padding-left: 26px;
  box-sizing: border-box;
}
.page-cart .content .el-input-number--minit {
  width: 120px;
}
.cart_list_cat {
  height: 46px;
  line-height: 36px;
  font-size: 18px;
  padding-left: 10px;
  color: #000;
  border-bottom: 4px solid #e2333f;
  display: flex;
  span:nth-child(2),
  span:nth-child(3) {
    line-height: 40px;
    margin-left: 4px;
  }
}

.cart_list_cat .sub_title {
  color: #999;
}
.selfcheckbox {
  display: none;
}
.selfcheckbox + label {
  background-color: #ffffff;
  border: 1px solid #d3d3d3;
  width: 18px;
  height: 18px;
  display: inline-block;
  text-align: center;
  vertical-align: middle;
  line-height: 18px;
}
.selfcheckbox:checked + label {
  border: 0;
  background-size: cover;
  background: url(../../assets/images/checked.png) no-repeat;
}
.product-table {
  width: 100%;
  border: 1px solid #eee;
  margin-top: -19px;

  .td-radio {
    padding-left: 23px;
  }

  .td-product {
    width: 580px;
    position: relative;
    padding-left: 100px;
  }
  .td-price,
  .td-count,
  .td-total,
  .td-actions {
    width: 150px;
    text-align: center;
  }
  .td-price {
    padding-left: 10px;
    box-sizing: border-box;
  }
  .product-item {
    height: 100px;
    position: relative;
    .image {
      width: 80px;
      height: 80px;
      display: block;
      position: absolute;
      left: 20px;
      top: 10px;
      border: 1px solid #dbdbdb;
      img {
        width: 100%;
        height: 100%;
      }
    }

    .info {
      font-size: 14px;
      color: #6c6c6c;
      padding-left: 15px;
      .name {
        margin-bottom: 5px;
        cursor: pointer;
      }
      .product-type {
        color: #999;
        display: flex;
        .type {
          display: inline-block;
          white-space: nowrap;
          max-width: 300px;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .reset {
          margin-left: 10px;
          color: #e2333f;
          cursor: pointer;
        }
      }
      .sku {
        color: #999;
      }
      .refresh-wrap {
        cursor: pointer;
        color: #ffaf0f;
        font-size: 14px;
        margin-top: 6px;
        span {
          display: inline-block;
          padding: 1px 5px;
          background: #ffaf0f;
          color: #fff;
          margin-right: 2px;
          border-radius: 4px;
          transform: scale(0.8);
        }
      }
    }
    .action-delete {
      font-size: 14px;
      color: #666;
      cursor: pointer;
      img {
        width: 15px;
      }
    }
  }
}
.page-cart /deep/ .el-checkbox__inner {
  width: 20px;
  height: 20px;
  line-height: 20px;
  border-radius: 0;
  &::after {
    height: 12px;
    left: 7px;
  }
  &:hover {
    border-color: #e2333f;
  }
}
.page-cart /deep/ .el-checkbox__input.is-checked .el-checkbox__inner,
.page-cart /deep/ .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #e2333f;
  border-color: #e2333f;
}
.page-cart /deep/ .el-checkbox__input.is-focus .el-checkbox__inner {
  border-color: #e2333f;
}
.cart-footer-info {
  border-top: 1px solid #e0e0e0;
  border-bottom: 1px solid #e0e0e0;
  padding: 30px 0;
  text-align: right;
  margin: 0 60px;
  line-height: 40px;
}
.cart-footer {
  clear: both;
  width: 100%;
  background: #f9f9f9;
  color: #999;
  overflow: hidden !important;
  padding: 30px 30px 60px;
  border-top: 1px solid #e0e0e0;
  margin-top: 25px !important;
  .address {
    text-align: right;
    font-size: 16px;
    color: #666;
    // padding: 15px 0;
    overflow: hidden;
    margin-bottom: 15px;
  }
  .cart_check_delete {
    height: 72px;
    line-height: 72px;
    margin-left: 23px;
    float: left;
    .delete_action {
      &:hover {
        color: #e2333f;
      }
      margin-left: 20px;
      cursor: pointer;
    }
  }
  .total-final {
    text-align: right;
    .express_rule_ico {
      margin-top: 5px;
      margin-left: 800px;
      color: #666;
      .el-icon {
        color: #fe9900;
      }
    }
    .product-count {
      margin-right: 10px;
      color: #222222;
    }
    .price {
      font-size: 26px;
      color: #e2333f;
      margin-right: 10px;
    }
    .red_text {
      color: #e2333f;
    }
  }
  .btn-checkout {
    cursor: pointer;
    width: 160px;
    background: #e2333f;
    color: #fff;
    right: 0;
    top: 0;
    text-align: center;
    font-size: 16px;
    line-height: 48px;
    font-weight: 300;
    float: right;
    border-radius: 5px;
  }
}
.cart-footer-cart {
  padding: 0;
  background: #ffffff;
  border: 1px solid #f1f1f1;
  .btn-checkout {
    height: 70px;
    line-height: 70px;
    font-size: 24px;
    width: 120px;
    border-radius: 0;
  }
  .cart_check_delete {
    height: 70px;
    line-height: 70px;
    span {
      vertical-align: middle;
    }
  }
  .total-final {
    p {
      margin-top: 4px;
    }
  }
}
.checkbg {
  background-color: #fff9f6;
}
.red_word {
  color: #fb0010;
}
/deep/ .el-dialog__body {
  padding: 0 20px;
}
/deep/ .dialog-footer {
  display: flex;
  justify-content: center;
  > div {
    width: 180px;
    height: 45px;
    text-align: center;
    line-height: 45px;
    margin: 30px 12px 0;
    border-radius: 4px;
    font-size: 18px;
    box-sizing: border-box;
    cursor: pointer;
  }
  > div:first-child {
    border: 1px solid #ccc;
    color: #333;
  }
  > div:last-child {
    color: #fff;
    background: #e2343f;
  }
  > .grey {
    background: #ccc !important;
  }
}
.header {
  display: flex;
  > img {
    width: 100px;
    height: 100px;
  }
  > .title {
    margin-left: 20px;
    width: 80%;
    > .name {
      color: #333;
      font-size: 16px;
    }
    > .price {
      font-size: 20px;
      color: #e2343f;
      margin-top: 10px;
    }
  }
}
.goods-small-text {
  line-height: 40px;
  color: #222;
  min-height: 234px;
  > div > span {
    color: #999;
    display: inline-block;
    width: 64px;
    text-align-last: justify;
    margin-right: 20px;
  }
  .can_buy_status {
    text-align-last: auto;
    width: 300px;
  }
  .star-gray {
    position: relative;
    top: 5px;
    width: 120px;
    height: 24px;
    display: inline-block;
    background-image: url("../../assets/images/star_g.png");
    background-repeat: repeat-x;
    margin-right: 20px;
    .star-red {
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      background-image: url("../../assets/images/star_r.png");
      background-repeat: repeat-x;
    }
  }
  .el-input,
  .el-input__inner {
    height: 28px;
    line-height: 28px;
    border-radius: 0;
    // border: none !important;
  }

  .el-input-number {
    height: 26px;
    line-height: 26px;
    margin-left: -5px;
  }
  .specification {
    display: inline-block;
    width: calc(100% - 120px);
  }
  b {
    display: inline-block;
    height: 30px;
    text-align: center;
    line-height: 30px;
    font-weight: normal;
    background: rgba(255, 255, 255, 1);
    border: 1px solid #dadada;
    padding: 0 10px;
    margin: 10px 10px 0 0;
    cursor: pointer;
    &.actived {
      border: 1px solid rgba(252, 0, 16, 1);
    }
  }
  .disabled {
    border: 1px dashed #aaa;
    background-color: #f0f0f0;
  }
}
.dialog-title {
  text-align: center;
  color: #333;
}

// 凑单提示
.freightTips {
  position: absolute;
  right: 0;
  font-size: 14px;
  font-weight: 400;
  color: #666666;

  .el-icon {
    color: #fe9900;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/shopping-cart/index.vue